// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "client-viewer/" + ({"99":"mobile/playback","273":"widget/vod-player","290":"mobile-overlay","812":"mobile/share-popup-content"}[chunkId] || chunkId) + ".chunk.min.js";
};